import { ViewStyle } from 'react-native';
import { Styles } from '../../types/styles';
import { PressableIconProps } from '../PressableIcon/PressableIcon.types';
import { InputState } from './Input.types';
import { IconProps } from '../Icon/Icon.types';

export const INPUT_CONTAINER_STYLE: Record<InputState, Styles<ViewStyle>> = {
  default: {
    flexDirection: 'row',
    height: 'space-1400',
    borderWidth: 'border-width-025',
    borderRadius: 'radius-200',
    borderColor: 'borderSecondary',
    backgroundColor: 'inputBackground',
  },
  focused: {
    borderColor: 'borderActive',
  },
  disabled: {
    pointerEvents: 'none',
    borderColor: 'borderPrimaryDisabled',
    backgroundColor: 'inputBackgroundDisabled',
  },
  error: {
    borderColor: 'borderError',
  },
};

export const INPUT_STYLE: Record<
  Extract<InputState, 'default' | 'disabled'>,
  Styles<ViewStyle>
> = {
  default: {
    fontSize: 'text-200',
    fontFamily: 'Inter-SemiBold',
    paddingTop: 'space-600',
    paddingBottom: 'space-200',
    paddingHorizontal: 'space-300',
    color: 'darkSurfacePrimary',
  },
  disabled: {
    color: 'darkSurfaceDisabled',
  },
};

export const INPUT_NON_FLOATING_PLACEHOLDER_STYLE: Styles<ViewStyle> = {
  paddingLeft: 'space-100',
  paddingTop: 'space-0',
  paddingBottom: 'space-0',
  height: '100%',
};

export const INPUT_ICON_STYLE: Partial<IconProps> = {
  alignSelf: 'center',
  color: 'darkSurfaceSecondary',
  marginLeft: 'space-400',
};

export const CLEAR_ICON_STYLE: Pick<
  PressableIconProps,
  keyof Styles<ViewStyle> | 'iconWidth' | 'iconHeight' | 'backgroundColor'
> = {
  position: 'absolute',
  top: 'space-400',
  right: 'space-400',
  color: 'iconPrimary',
  width: 'space-500',
  height: 'space-500',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'iconSecondary',
  borderRadius: 'radius-full',
};

export const SECURE_TEXT_ICON_STYLE: Pick<
  PressableIconProps,
  keyof Styles<ViewStyle> | 'iconWidth' | 'iconHeight' | 'backgroundColor'
> = {
  position: 'absolute',
  top: 'space-400',
  right: 'space-1200',
  alignItems: 'center',
  justifyContent: 'center',
};

export const DROP_DOWN_ICON_STYLE: Pick<
  PressableIconProps,
  keyof Styles<ViewStyle> | 'iconWidth' | 'iconHeight' | 'backgroundColor'
> = {
  position: 'absolute',
  top: 'space-400',
  right: 'space-400',
  alignItems: 'center',
  justifyContent: 'center',
};
